module.exports = __webpack_public_path__ + "98bb2c0966a400b07e34d12996508472.jpg";